import { useEffect, useState } from "react";
import StandardModal from "../../Fundamentals/Modal/StandardModal";
import SubscriptionItemTerminationForm from "../../Customer/VOSS/Subscriptions/SubscriptionItemTerminationForm";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import subscriptionActions from "../../../Actions/Voss/subscriptionActions";
import forms from "../../../Constants/forms";
import formActions from "../../../Actions/formActions";
import useModal from "../../../Hooks/useModal";
import { VossSubscriptionItemStatus } from "../../../Constants/VOSS/vossSubscriptionItemStatus";

export default function ProductGroupTerminationModal({ subscription, productGroup }) {
    const { t } = useTranslation();
    const { closeModal } = useModal();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const form = useSelector(state => state.FormReducer.forms[forms.terminateProductGroup]);

    useEffect(() => {
        dispatch(subscriptionActions.initializeTerminateSubscriptionItemForm(forms.terminateProductGroup));

        return () => {
            dispatch(formActions.cancelFormEditing(forms.terminateProductGroup));
        }
    }, []);

    const onSubmit = () => {
        dispatch(formActions.submitForm(form, () => {
            setIsLoading(true);
            dispatch(subscriptionActions.terminateSubscriptionProductGroup(subscription.id, productGroup.id, form, () => {
                dispatch(subscriptionActions.getSubscriptionProductGroups(subscription.id, VossSubscriptionItemStatus.Active));
                setIsLoading(false);
                closeModal();
            }));
        }));
    }

    const onChange = (field, value) => {
        dispatch(formActions.changeMultiFormField(form, field, value));
    }

    return <StandardModal isLoading={!form || isLoading} onSubmit={onSubmit} title={t("subscriptiontermination.terminationof", { product: productGroup.name })}>
        <SubscriptionItemTerminationForm form={form} subscription={subscription} onChange={onChange} />
    </StandardModal>
}